import "./castable.scss";
import { useState } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import { Helmet } from "react-helmet";


export default function Castable() {
    const img = [
        "https://res.cloudinary.com/dobxtcf1w/image/upload/v1731587261/castable3_emrfhp.jpg",
        "https://res.cloudinary.com/dobxtcf1w/image/upload/v1731587262/castable4_ah80ba.jpg",
        "https://res.cloudinary.com/dobxtcf1w/image/upload/v1731587261/castable2_lb3z15.jpg",
        "https://res.cloudinary.com/dobxtcf1w/image/upload/v1731587261/castable1_g4wy7d.jpg"
    ]
    const [currentImg, setCurrentImg] = useState(0)
  return (
    
    <div className='main_wrapper'>
        <Helmet>
        <title>Castable Refractory Cement || Raydron, Lagos, Nigeria</title>
        <meta name="description" content="At Raydron we supply high end monolithic refractory castable cement for lining furnaces, kilns, dryers, etc"/>
        <meta name="keywords" content="castable refractory cement, monolithic castable refarctory cement, Whytheat A, Whytheat K, Durax, Castable-90, Lagos Nigeria" />
        </Helmet>
        <h3>Castable Refractory Cement</h3>
        <div className='product_wrapper'>
            <div className="image_column">
                <div className="main_image">
                    <img className = 'imgMain' src={img[currentImg]} alt="product_image" />
                </div>
                <div className="slider_image_row">
                    <div className="slider_image">
                        <img className = 'imgSlide' src={img[0]} alt="product_image" onClick={(e)=>(setCurrentImg(0))}/>
                    </div>    
                    <div className="slider_image">
                        <img className = 'imgSlide' src={img[1]} alt="product_image" onClick={(e)=>(setCurrentImg(1))}/>
                    </div>
                    <div className="slider_image">
                        <img className = 'imgSlide' src={img[2]} alt="product_image"  onClick={(e)=>(setCurrentImg(2))} />
                    </div>
                    <div className="slider_image">
                        <img className = 'imgSlide' src={img[3]} alt="product_image"  onClick={(e)=>(setCurrentImg(3))} />
                    </div>
                </div>

            </div>
            <div className="description">
                <p className='text'>
                Key Characteristics of Our Castable Refractory Cement:
                </p>
                <ul>
                    <li>
                    <span className="checkCircle"><FontAwesomeIcon icon={faCheckCircle}/></span>Can withstand up to  1,800°C. 
                    </li>
                    <li>
                    <span className="checkCircle"><FontAwesomeIcon icon={faCheckCircle}/></span>Highly insulating
                    </li>
                    <li>
                    <span className="checkCircle"><FontAwesomeIcon icon={faCheckCircle}/></span>Resistant to thermal shock
                    </li>
                    <li>
                    <span className="checkCircle"><FontAwesomeIcon icon={faCheckCircle}/></span>Can be cast into various shapes
                    </li>
                    <li>
                    <span className="checkCircle"><FontAwesomeIcon icon={faCheckCircle}/></span>Durable
                    </li>
                </ul>
                <a href="https://wa.me/+2348066816640" target="_blank" rel="noreferrer" ><button className="btnWAP">Chat Us to Buy</button></a>
            </div>
        </div>
        <div className="details">
        Composition


Alumina (Al₂O₃): Provides high-temperature stability and strength.
Silica (SiO₂): Adds structural integrity and heat resistance.
Calcium Aluminate Cement: Acts as the binder that hardens and sets the material.
Other Additives: May include materials like perlite or vermiculite for insulation or other ingredients to improve bonding or heat resistance.
Common Applications
Furnaces and Kilns: Used for lining industrial furnaces, kilns, and boilers.
Fireplace and Pizza Oven Linings: Cast to form custom shapes or linings for ovens and fireplaces.
Chimneys and Flue Linings: Often applied to protect metal or masonry chimneys from intense heat.
Installation and Use
Mixing: Usually comes in a powder form that needs to be mixed with water according to manufacturer guidelines.
Curing: Proper curing, often involving slow drying followed by gradual heating, is crucial to ensure durability and performance.
Application: Can be cast, poured, or troweled into place, and often requires forms or molds to shape it.
                </div>
    </div>
  )
}
